var map = {
	"./ATM.svg": 1278,
	"./App-Store.svg": 510,
	"./Branch.svg": 1279,
	"./DELETEselectArrowDown.svg": 1280,
	"./DELETEselectArrowUp.svg": 1281,
	"./DELETEstyledmenu-arrow-down.svg": 1282,
	"./Google-Play.svg": 511,
	"./ID.svg": 1283,
	"./InvitationCode.svg": 1284,
	"./InvitationCode_viejo.svg": 1285,
	"./LifeTest.svg": 1286,
	"./addNote.svg": 1287,
	"./administrar.svg": 1288,
	"./administration.svg": 1289,
	"./administration_viejo.svg": 1290,
	"./administrator.svg": 1291,
	"./agenda.svg": 1292,
	"./alert-big.svg": 1293,
	"./alert.svg": 1294,
	"./alexa.svg": 1295,
	"./app-download-qr.png": 512,
	"./app-icon.png": 1296,
	"./app-store-badge.png": 513,
	"./arrow-down.png": 1297,
	"./arrow-up.png": 1298,
	"./arrowLeft.svg": 1299,
	"./arrowRight.svg": 1300,
	"./assistants-big.svg": 1301,
	"./attach.svg": 1302,
	"./attachment.svg": 1303,
	"./avatarImages/avatar-0.svg": 1304,
	"./avatarImages/avatar-1.svg": 1305,
	"./avatarImages/avatar-10.svg": 1306,
	"./avatarImages/avatar-11.svg": 1307,
	"./avatarImages/avatar-2.svg": 1308,
	"./avatarImages/avatar-3.svg": 1309,
	"./avatarImages/avatar-4.svg": 1310,
	"./avatarImages/avatar-5.svg": 1311,
	"./avatarImages/avatar-6.svg": 1312,
	"./avatarImages/avatar-7.svg": 1313,
	"./avatarImages/avatar-8.svg": 1314,
	"./avatarImages/avatar-9.svg": 1315,
	"./background.png": 1316,
	"./bell.svg": 1317,
	"./bg.gif": 1318,
	"./bi-logo.svg": 1319,
	"./bibank_logo.png": 1320,
	"./bioIcon.svg": 1321,
	"./bk_chart.svg": 1322,
	"./businessPortfolio.svg": 1323,
	"./cancel_grey.svg": 1324,
	"./cancel_red.svg": 1325,
	"./cerrarSesion.svg": 1326,
	"./channel-assistant.svg": 1327,
	"./channel-assistants.svg": 1328,
	"./channel-mobile.svg": 1329,
	"./channel-web.svg": 1330,
	"./check.svg": 1331,
	"./check_new.svg": 1332,
	"./checks.svg": 1333,
	"./chevromLeft.svg": 1334,
	"./chevromRight.svg": 1335,
	"./cloud-download.svg": 1336,
	"./collapse-sidebar.svg": 1337,
	"./coloredIcons/accounts.svg": 1338,
	"./coloredIcons/agenda.svg": 1339,
	"./coloredIcons/alert.svg": 1340,
	"./coloredIcons/browser-not-available.svg": 1341,
	"./coloredIcons/chronometer.svg": 1342,
	"./coloredIcons/credit-card-expired.svg": 1343,
	"./coloredIcons/creditCards.svg": 1344,
	"./coloredIcons/deposits.svg": 1345,
	"./coloredIcons/desktop.svg": 1346,
	"./coloredIcons/device-not-available.svg": 1347,
	"./coloredIcons/doc.svg": 1348,
	"./coloredIcons/failure.svg": 1349,
	"./coloredIcons/folder-empty.svg": 1350,
	"./coloredIcons/folder.svg": 1351,
	"./coloredIcons/loan-expired.svg": 1352,
	"./coloredIcons/loans.svg": 1353,
	"./coloredIcons/lock.svg": 1354,
	"./coloredIcons/mailbox-empty.svg": 1355,
	"./coloredIcons/mailbox.svg": 1356,
	"./coloredIcons/messenger.svg": 1357,
	"./coloredIcons/money-red.svg": 1358,
	"./coloredIcons/money.svg": 1359,
	"./coloredIcons/no-connection-gray.svg": 1360,
	"./coloredIcons/no-more-transactions.svg": 1361,
	"./coloredIcons/notifications-empty.svg": 1362,
	"./coloredIcons/notifications.svg": 1363,
	"./coloredIcons/search-no-results.svg": 1364,
	"./coloredIcons/search.svg": 1365,
	"./coloredIcons/setup.svg": 1366,
	"./coloredIcons/success.svg": 1367,
	"./coloredIcons/transfer.svg": 1368,
	"./coloredIcons/user.svg": 1369,
	"./coloredIcons/wallet.svg": 1370,
	"./comercioExterior.svg": 1371,
	"./communication.svg": 1372,
	"./compose.svg": 1373,
	"./corporate.svg": 1374,
	"./corporateGroup.svg": 1375,
	"./creditCards.svg": 1376,
	"./cross-primary-ios.svg": 1377,
	"./cross-primary.svg": 1378,
	"./cross.svg": 1379,
	"./cross_viejo.svg": 1380,
	"./cuentas.svg": 1381,
	"./cuentas_old.svg": 1382,
	"./currencyExchange.svg": 1383,
	"./currencyFlags/001-mauritius.svg": 1384,
	"./currencyFlags/003-austria.svg": 1385,
	"./currencyFlags/004-oman.svg": 1386,
	"./currencyFlags/005-ethiopia.svg": 1387,
	"./currencyFlags/006-tanzania.svg": 1388,
	"./currencyFlags/007-nicaragua.svg": 1389,
	"./currencyFlags/008-estonia.svg": 1390,
	"./currencyFlags/009-uganda.svg": 1391,
	"./currencyFlags/010-slovenia.svg": 1392,
	"./currencyFlags/011-zimbabwe.svg": 1393,
	"./currencyFlags/012-sao-tome-and-prince.svg": 1394,
	"./currencyFlags/013-italy.svg": 1395,
	"./currencyFlags/014-wales.svg": 1396,
	"./currencyFlags/015-el-salvador.svg": 1397,
	"./currencyFlags/016-nepal.svg": 1398,
	"./currencyFlags/017-christmas-island.svg": 1399,
	"./currencyFlags/018-lebanon.svg": 1400,
	"./currencyFlags/019-ceuta.svg": 1401,
	"./currencyFlags/020-iraq.svg": 1402,
	"./currencyFlags/021-cook-islands.svg": 1403,
	"./currencyFlags/022-syria.svg": 1404,
	"./currencyFlags/023-cocos-island.svg": 1405,
	"./currencyFlags/024-honduras.svg": 1406,
	"./currencyFlags/025-anguilla.svg": 1407,
	"./currencyFlags/026-qatar.svg": 1408,
	"./currencyFlags/027-american-samoa.svg": 1409,
	"./currencyFlags/028-puerto-rico.svg": 1410,
	"./currencyFlags/029-comoros.svg": 1411,
	"./currencyFlags/030-north-korea.svg": 1412,
	"./currencyFlags/031-corsica.svg": 1413,
	"./currencyFlags/032-zambia.svg": 1414,
	"./currencyFlags/033-saint-kitts-and-nevis.svg": 1415,
	"./currencyFlags/034-china.svg": 1416,
	"./currencyFlags/035-luxembourg.svg": 1417,
	"./currencyFlags/036-central-african-republic.svg": 1418,
	"./currencyFlags/037-jamaica.svg": 1419,
	"./currencyFlags/038-cape-verde.svg": 1420,
	"./currencyFlags/039-monaco.svg": 1421,
	"./currencyFlags/040-bhutan.svg": 1422,
	"./currencyFlags/041-paraguay.svg": 1423,
	"./currencyFlags/042-aruba.svg": 1424,
	"./currencyFlags/043-montserrat.svg": 1425,
	"./currencyFlags/044-latvia.svg": 1426,
	"./currencyFlags/045-andorra.svg": 1427,
	"./currencyFlags/046-micronesia.svg": 1428,
	"./currencyFlags/047-dominican-republic.svg": 1429,
	"./currencyFlags/048-abkhazia.svg": 1430,
	"./currencyFlags/049-tunisia.svg": 1431,
	"./currencyFlags/050-mauritania.svg": 1432,
	"./currencyFlags/051-cayman-islands.svg": 1433,
	"./currencyFlags/052-kosovo.svg": 1434,
	"./currencyFlags/053-ghana.svg": 1435,
	"./currencyFlags/054-canary-islands.svg": 1436,
	"./currencyFlags/055-scotland.svg": 1437,
	"./currencyFlags/056-guinea-bissau.svg": 1438,
	"./currencyFlags/057-burundi.svg": 1439,
	"./currencyFlags/058-myanmar.svg": 1440,
	"./currencyFlags/059-gabon.svg": 1441,
	"./currencyFlags/060-benin.svg": 1442,
	"./currencyFlags/061-saba-island.svg": 1443,
	"./currencyFlags/062-namibia.svg": 1444,
	"./currencyFlags/063-japan.svg": 1445,
	"./currencyFlags/064-lithuania.svg": 1446,
	"./currencyFlags/065-eritrea.svg": 1447,
	"./currencyFlags/066-chad.svg": 1448,
	"./currencyFlags/067-kenya.svg": 1449,
	"./currencyFlags/068-djibouti.svg": 1450,
	"./currencyFlags/069-british-indian-ocean-territory.svg": 1451,
	"./currencyFlags/070-tuvalu-1.svg": 1452,
	"./currencyFlags/071-serbia.svg": 1453,
	"./currencyFlags/072-bonaire.svg": 1454,
	"./currencyFlags/073-togo.svg": 1455,
	"./currencyFlags/074-kazakhstan.svg": 1456,
	"./currencyFlags/075-antigua-and-barbuda.svg": 1457,
	"./currencyFlags/076-suriname.svg": 1458,
	"./currencyFlags/077-jordan.svg": 1459,
	"./currencyFlags/078-belize.svg": 1460,
	"./currencyFlags/079-st-barts.svg": 1461,
	"./currencyFlags/080-iceland.svg": 1462,
	"./currencyFlags/081-bermuda.svg": 1463,
	"./currencyFlags/082-united-nations.svg": 1464,
	"./currencyFlags/083-somalia.svg": 1465,
	"./currencyFlags/084-barbados.svg": 1466,
	"./currencyFlags/085-solomon-islands.svg": 1467,
	"./currencyFlags/086-nigeria.svg": 1468,
	"./currencyFlags/087-aland-islands.svg": 1469,
	"./currencyFlags/088-uruguay.svg": 1470,
	"./currencyFlags/089-sint-maarten.svg": 1471,
	"./currencyFlags/090-burkina-faso.svg": 1472,
	"./currencyFlags/091-slovakia.svg": 1473,
	"./currencyFlags/092-sierra-leone.svg": 1474,
	"./currencyFlags/093-basque-country.svg": 1475,
	"./currencyFlags/094-south-korea.svg": 1476,
	"./currencyFlags/095-pitcairn-islands.svg": 1477,
	"./currencyFlags/096-mozambique.svg": 1478,
	"./currencyFlags/097-san-marino.svg": 1479,
	"./currencyFlags/098-guatemala.svg": 1480,
	"./currencyFlags/099-albania.svg": 1481,
	"./currencyFlags/100-pakistan.svg": 1482,
	"./currencyFlags/101-northern-cyprus.svg": 1483,
	"./currencyFlags/102-balearic-islands.svg": 1484,
	"./currencyFlags/103-marshall-island.svg": 1485,
	"./currencyFlags/104-ecuador.svg": 1486,
	"./currencyFlags/105-cameroon.svg": 1487,
	"./currencyFlags/106-panama.svg": 1488,
	"./currencyFlags/107-kwait.svg": 1489,
	"./currencyFlags/108-armenia.svg": 1490,
	"./currencyFlags/109-romania.svg": 1491,
	"./currencyFlags/110-guinea.svg": 1492,
	"./currencyFlags/111-afghanistan.svg": 1493,
	"./currencyFlags/112-laos.svg": 1494,
	"./currencyFlags/113-greenland.svg": 1495,
	"./currencyFlags/114-british-virgin-islands.svg": 1496,
	"./currencyFlags/115-hungary.svg": 1497,
	"./currencyFlags/116-curacao.svg": 1498,
	"./currencyFlags/117-angola.svg": 1499,
	"./currencyFlags/118-malasya.svg": 1500,
	"./currencyFlags/119-brunei.svg": 1501,
	"./currencyFlags/120-bahamas.svg": 1502,
	"./currencyFlags/121-new-zealand.svg": 1503,
	"./currencyFlags/123-british-columbia.svg": 1504,
	"./currencyFlags/124-vatican-city.svg": 1505,
	"./currencyFlags/125-finland.svg": 1506,
	"./currencyFlags/126-botswana.svg": 1507,
	"./currencyFlags/127-sri-lanka.svg": 1508,
	"./currencyFlags/128-spain.svg": 1509,
	"./currencyFlags/129-ossetia.svg": 1510,
	"./currencyFlags/130-sicily.svg": 1511,
	"./currencyFlags/131-chile.svg": 1512,
	"./currencyFlags/132-bosnia-and-herzegovina.svg": 1513,
	"./currencyFlags/133-saudi-arabia.svg": 1514,
	"./currencyFlags/134-liechtenstein.svg": 1515,
	"./currencyFlags/135-belarus.svg": 1516,
	"./currencyFlags/136-iran.svg": 1517,
	"./currencyFlags/137-fiji.svg": 1518,
	"./currencyFlags/138-bahrain.svg": 1519,
	"./currencyFlags/139-venezuela.svg": 1520,
	"./currencyFlags/140-east-timor.svg": 1521,
	"./currencyFlags/141-azerbaijan.svg": 1522,
	"./currencyFlags/142-tibet.svg": 1523,
	"./currencyFlags/143-norway.svg": 1524,
	"./currencyFlags/144-algeria.svg": 1525,
	"./currencyFlags/145-ukraine.svg": 1526,
	"./currencyFlags/146-gambia.svg": 1527,
	"./currencyFlags/147-bangladesh.svg": 1528,
	"./currencyFlags/148-madeira.svg": 1529,
	"./currencyFlags/149-czech-republic.svg": 1530,
	"./currencyFlags/150-bolivia.svg": 1531,
	"./currencyFlags/151-united-arab-emirates.svg": 1532,
	"./currencyFlags/152-kyrgyzstan.svg": 1533,
	"./currencyFlags/153-cuba.svg": 1534,
	"./currencyFlags/154-swaziland.svg": 1535,
	"./currencyFlags/155-israel.svg": 1536,
	"./currencyFlags/156-costa-rica.svg": 1537,
	"./currencyFlags/157-republic-of-the-congo.svg": 1538,
	"./currencyFlags/158-egypt.svg": 1539,
	"./currencyFlags/159-cambodia.svg": 1540,
	"./currencyFlags/160-northern-marianas-islands.svg": 1541,
	"./currencyFlags/161-ivory-coast.svg": 1542,
	"./currencyFlags/162-germany.svg": 1543,
	"./currencyFlags/163-papua-new-guinea.svg": 1544,
	"./currencyFlags/164-croatia.svg": 1545,
	"./currencyFlags/165-belgium.svg": 1546,
	"./currencyFlags/166-morocco.svg": 1547,
	"./currencyFlags/167-macao.svg": 1548,
	"./currencyFlags/168-bulgaria.svg": 1549,
	"./currencyFlags/169-liberia.svg": 1550,
	"./currencyFlags/170-greece.svg": 1551,
	"./currencyFlags/171-galapagos-islands.svg": 1552,
	"./currencyFlags/172-st-lucia.svg": 1553,
	"./currencyFlags/173-mali.svg": 1554,
	"./currencyFlags/174-denmark.svg": 1555,
	"./currencyFlags/175-rapa-nui.svg": 1556,
	"./currencyFlags/176-lesotho.svg": 1557,
	"./currencyFlags/177-colombia.svg": 1558,
	"./currencyFlags/178-palau.svg": 1559,
	"./currencyFlags/179-ireland.svg": 1560,
	"./currencyFlags/180-french-polynesia.svg": 1561,
	"./currencyFlags/181-trinidad-and-tobago.svg": 1562,
	"./currencyFlags/182-niue.svg": 1563,
	"./currencyFlags/183-hong-kong.svg": 1564,
	"./currencyFlags/184-sweden.svg": 1565,
	"./currencyFlags/185-haiti.svg": 1566,
	"./currencyFlags/186-dominica.svg": 1567,
	"./currencyFlags/187-vanuatu.svg": 1568,
	"./currencyFlags/188-peru.svg": 1569,
	"./currencyFlags/189-equatorial-guinea.svg": 1570,
	"./currencyFlags/190-uzbekistn.svg": 1571,
	"./currencyFlags/191-tonga.svg": 1572,
	"./currencyFlags/192-philippines.svg": 1573,
	"./currencyFlags/193-norfolk-island.svg": 1574,
	"./currencyFlags/194-malta.svg": 1575,
	"./currencyFlags/195-france.svg": 1576,
	"./currencyFlags/196-tajikistan.svg": 1577,
	"./currencyFlags/197-melilla.svg": 1578,
	"./currencyFlags/198-argentina.svg": 1579,
	"./currencyFlags/199-sudan.svg": 1580,
	"./currencyFlags/200-south-africa.svg": 1581,
	"./currencyFlags/201-martinique.svg": 1582,
	"./currencyFlags/202-taiwan.svg": 1583,
	"./currencyFlags/203-sahrawi-arab-democratic-republic.svg": 1584,
	"./currencyFlags/204-guernsey.svg": 1585,
	"./currencyFlags/205-switzerland.svg": 1586,
	"./currencyFlags/206-rwanda.svg": 1587,
	"./currencyFlags/207-guam.svg": 1588,
	"./currencyFlags/208-palestine.svg": 1589,
	"./currencyFlags/209-indonesia.svg": 1590,
	"./currencyFlags/210-grenada.svg": 1591,
	"./currencyFlags/211-poland.svg": 1592,
	"./currencyFlags/212-moldova.svg": 1593,
	"./currencyFlags/213-gibraltar.svg": 1594,
	"./currencyFlags/214-malawi.svg": 1595,
	"./currencyFlags/215-falkland-islands.svg": 1596,
	"./currencyFlags/216-england.svg": 1597,
	"./currencyFlags/217-virgin-islands.svg": 1598,
	"./currencyFlags/218-turkey.svg": 1599,
	"./currencyFlags/219-isle-of-man.svg": 1600,
	"./currencyFlags/220-vietnam.svg": 1601,
	"./currencyFlags/221-tuvalu.svg": 1602,
	"./currencyFlags/222-niger.svg": 1603,
	"./currencyFlags/223-turks-and-caicos.svg": 1604,
	"./currencyFlags/224-portugal.svg": 1605,
	"./currencyFlags/225-maldives.svg": 1606,
	"./currencyFlags/226-united-states.svg": 1607,
	"./currencyFlags/227-senegal.svg": 1608,
	"./currencyFlags/228-nauru.svg": 1609,
	"./currencyFlags/229-turkmenistan.svg": 1610,
	"./currencyFlags/230-singapore.svg": 1611,
	"./currencyFlags/231-libya.svg": 1612,
	"./currencyFlags/232-yemen.svg": 1613,
	"./currencyFlags/233-transnistria.svg": 1614,
	"./currencyFlags/234-australia.svg": 1615,
	"./currencyFlags/235-tokelau.svg": 1616,
	"./currencyFlags/236-republic-of-macedonia.svg": 1617,
	"./currencyFlags/237-netherlands.svg": 1618,
	"./currencyFlags/238-thailand.svg": 1619,
	"./currencyFlags/239-montenegro.svg": 1620,
	"./currencyFlags/240-azores-islands.svg": 1621,
	"./currencyFlags/241-st-vincent-and-the-grenadines.svg": 1622,
	"./currencyFlags/242-madagascar.svg": 1623,
	"./currencyFlags/243-canada.svg": 1624,
	"./currencyFlags/244-south-sudan.svg": 1625,
	"./currencyFlags/245-jersey.svg": 1626,
	"./currencyFlags/246-india.svg": 1627,
	"./currencyFlags/247-somaliland.svg": 1628,
	"./currencyFlags/248-russia.svg": 1629,
	"./currencyFlags/249-democratic-republic-of-congo.svg": 1630,
	"./currencyFlags/250-sint-eustatius.svg": 1631,
	"./currencyFlags/251-samoa.svg": 1632,
	"./currencyFlags/252-mexico.svg": 1633,
	"./currencyFlags/253-seychelles.svg": 1634,
	"./currencyFlags/254-nato.svg": 1635,
	"./currencyFlags/255-brazil.svg": 1636,
	"./currencyFlags/256-georgia.svg": 1637,
	"./currencyFlags/257-sardinia.svg": 1638,
	"./currencyFlags/258-mongolia.svg": 1639,
	"./currencyFlags/259-european-union.svg": 1640,
	"./currencyFlags/260-united-kingdom.svg": 1641,
	"./currencyFlags/261-kiribati.svg": 1642,
	"./currencyFlags/262-hawaii.svg": 1643,
	"./currencyFlags/ARS.svg": 1644,
	"./currencyFlags/BRL.svg": 1645,
	"./currencyFlags/CAD.svg": 1646,
	"./currencyFlags/CLP.svg": 1647,
	"./currencyFlags/EUR.svg": 1648,
	"./currencyFlags/GBP.svg": 1649,
	"./currencyFlags/JPY.svg": 1650,
	"./currencyFlags/USD.svg": 1651,
	"./currencyFlags/UYI.svg": 1652,
	"./currencyFlags/UYU.svg": 1653,
	"./delete-message.svg": 1654,
	"./depositoFijo.svg": 1655,
	"./desktop.svg": 1656,
	"./dispatcher.svg": 1657,
	"./documentOverlay.svg": 1658,
	"./download-app.svg": 1659,
	"./download-figma.svg": 1660,
	"./download-primary.svg": 1661,
	"./download.svg": 1662,
	"./download_old.svg": 1663,
	"./draft.svg": 1664,
	"./drawer-close.svg": 1665,
	"./e-mail.svg": 1666,
	"./editDashboard.svg": 1667,
	"./editPen.svg": 1668,
	"./email.svg": 1669,
	"./email_viejo.svg": 1670,
	"./en-flag.svg": 1671,
	"./error.svg": 1672,
	"./es-flag.svg": 1673,
	"./escritorio.svg": 1674,
	"./escritorio_viejo.svg": 1675,
	"./exclamation.svg": 1676,
	"./expand-sidebar.svg": 1677,
	"./eyeLooking.svg": 1678,
	"./faceOverlay.svg": 1679,
	"./faceOverlayDesktop.svg": 1680,
	"./facebook-messenger.svg": 1681,
	"./facebookLogo.svg": 1682,
	"./figma/flag/argentina.svg": 1683,
	"./figma/flag/brazil.svg": 1684,
	"./figma/flag/england.svg": 1685,
	"./figma/flag/japan.svg": 1686,
	"./figma/flag/uruguay.svg": 1687,
	"./figma/icon/FCE.svg": 1688,
	"./figma/icon/add.svg": 1689,
	"./figma/icon/administracion.svg": 1690,
	"./figma/icon/agenda.svg": 1691,
	"./figma/icon/arrow-back-mobile.svg": 1692,
	"./figma/icon/arrow-back.svg": 1693,
	"./figma/icon/arrow-down-filled.svg": 1694,
	"./figma/icon/arrow-down.svg": 1695,
	"./figma/icon/arrow-left-filled.svg": 1696,
	"./figma/icon/arrow-left.svg": 1697,
	"./figma/icon/arrow-right-filled.svg": 1698,
	"./figma/icon/arrow-right.svg": 1699,
	"./figma/icon/arrow-up.svg": 1700,
	"./figma/icon/arrow.svg": 1701,
	"./figma/icon/bell-white.svg": 1702,
	"./figma/icon/bell.svg": 1703,
	"./figma/icon/calendar-primary.svg": 1704,
	"./figma/icon/calendar.svg": 1705,
	"./figma/icon/cancel_green.svg": 1706,
	"./figma/icon/check.svg": 1707,
	"./figma/icon/cheques.svg": 1708,
	"./figma/icon/clear-filter.svg": 1709,
	"./figma/icon/cobros.svg": 1710,
	"./figma/icon/comex.svg": 1711,
	"./figma/icon/contacts.svg": 1712,
	"./figma/icon/corporate.svg": 1713,
	"./figma/icon/cross-white.svg": 1714,
	"./figma/icon/cross.svg": 1715,
	"./figma/icon/cuentas.svg": 1716,
	"./figma/icon/debin.svg": 1717,
	"./figma/icon/depositar-a-plazo.svg": 1718,
	"./figma/icon/download.svg": 1719,
	"./figma/icon/error.svg": 1720,
	"./figma/icon/eye-primary.svg": 1721,
	"./figma/icon/eye.svg": 1722,
	"./figma/icon/eyehide-primary.svg": 1723,
	"./figma/icon/eyehide.svg": 1724,
	"./figma/icon/filter-primary.svg": 1725,
	"./figma/icon/filter.svg": 1726,
	"./figma/icon/financiaciones-white.svg": 1727,
	"./figma/icon/financiaciones.svg": 1728,
	"./figma/icon/hamburguesa-white.svg": 1729,
	"./figma/icon/hamburguesa.svg": 1730,
	"./figma/icon/help-white.svg": 1731,
	"./figma/icon/help.svg": 1732,
	"./figma/icon/historial.svg": 1733,
	"./figma/icon/info-primary.svg": 1734,
	"./figma/icon/info.svg": 676,
	"./figma/icon/inicio.svg": 1735,
	"./figma/icon/inversiones.svg": 1736,
	"./figma/icon/lupa.svg": 1737,
	"./figma/icon/menu-ios-white.svg": 1738,
	"./figma/icon/menu-ios.svg": 1739,
	"./figma/icon/menu-mobile.svg": 1740,
	"./figma/icon/messages.svg": 1741,
	"./figma/icon/nuevo-white.svg": 1742,
	"./figma/icon/nuevo.svg": 1743,
	"./figma/icon/pagos.svg": 1744,
	"./figma/icon/qr-primary.svg": 1745,
	"./figma/icon/qr.svg": 1746,
	"./figma/icon/save.svg": 1747,
	"./figma/icon/share-primary.svg": 1748,
	"./figma/icon/share-white.svg": 1749,
	"./figma/icon/share.svg": 1750,
	"./figma/icon/success-primary.svg": 1751,
	"./figma/icon/success.svg": 1752,
	"./figma/icon/tick.svg": 1753,
	"./figma/icon/transacciones-pendientes.svg": 1754,
	"./figma/icon/transferencias-white.svg": 1755,
	"./figma/icon/transferencias.svg": 1756,
	"./figma/icon/upload-file-button.svg": 1757,
	"./figma/icon/upload.svg": 1758,
	"./figma/icon/user.svg": 1759,
	"./figma/icon/warning.svg": 1760,
	"./figma/illustrations/advertisement.svg": 1761,
	"./figma/illustrations/check-background.svg": 1762,
	"./figma/illustrations/document.svg": 1763,
	"./figma/illustrations/header-background.png": 1764,
	"./figma/illustrations/header-banner-loans.svg": 1765,
	"./figma/illustrations/header-banner-mobile.svg": 1766,
	"./figma/illustrations/header-banner-preaproved.svg": 1767,
	"./figma/illustrations/header-bg-secondary.png": 1768,
	"./figma/illustrations/header_banner.svg": 1769,
	"./figma/illustrations/imagotipo.svg": 1770,
	"./figma/illustrations/login-app-background.svg": 1771,
	"./figma/illustrations/login-background-mobile.svg": 1772,
	"./figma/illustrations/login-background.svg": 1773,
	"./figma/illustrations/logo-white.svg": 1774,
	"./figma/illustrations/logo.svg": 1775,
	"./figma/illustrations/notebook.svg": 1776,
	"./figma/illustrations/onboarding1.svg": 1777,
	"./figma/illustrations/onboarding10.svg": 1778,
	"./figma/illustrations/onboarding11.svg": 1779,
	"./figma/illustrations/onboarding12.svg": 1780,
	"./figma/illustrations/onboarding13.svg": 1781,
	"./figma/illustrations/onboarding14.svg": 1782,
	"./figma/illustrations/onboarding15.svg": 1783,
	"./figma/illustrations/onboarding16.svg": 1784,
	"./figma/illustrations/onboarding2.svg": 1785,
	"./figma/illustrations/onboarding3.svg": 1786,
	"./figma/illustrations/onboarding4.svg": 1787,
	"./figma/illustrations/onboarding5.svg": 1788,
	"./figma/illustrations/onboarding6.svg": 1789,
	"./figma/illustrations/onboarding7.svg": 1790,
	"./figma/illustrations/onboarding8desktop.svg": 1791,
	"./figma/illustrations/onboarding8mobile.svg": 1792,
	"./figma/illustrations/onboarding9.svg": 1793,
	"./figma/illustrations/onboardingPayway.svg": 1794,
	"./figma/illustrations/paywayLastStep.svg": 1795,
	"./figma/illustrations/rapipago.svg": 1796,
	"./figma/illustrations/selfie_anteojos.svg": 1797,
	"./figma/illustrations/selfie_fondo_claro.svg": 1798,
	"./figma/illustrations/selfie_iluminado.svg": 1799,
	"./figma/illustrations/selfie_ubicar_celular.svg": 1800,
	"./figma/illustrations/test.svg": 1801,
	"./figma/illustrations/ticket-alert.svg": 1802,
	"./figma/illustrations/ticket-dashed-line-vertical.svg": 1803,
	"./figma/illustrations/ticket-dashed-line.svg": 1804,
	"./figma/illustrations/ticket-pending-approval.svg": 1805,
	"./figma/illustrations/ticket-pending.svg": 1806,
	"./figma/illustrations/ticket-schedule.svg": 1807,
	"./figma/illustrations/ticket-success-with-errors.svg": 1808,
	"./figma/illustrations/ticket-success.svg": 1809,
	"./figma/illustrations/token1.svg": 1810,
	"./figma/illustrations/validate-identity.svg": 1811,
	"./figure-security-image.png": 1812,
	"./fileIconsByExtension/file-bmp.svg": 1813,
	"./fileIconsByExtension/file-default.svg": 1814,
	"./fileIconsByExtension/file-doc.svg": 1815,
	"./fileIconsByExtension/file-gif.svg": 1816,
	"./fileIconsByExtension/file-jpg.svg": 1817,
	"./fileIconsByExtension/file-pdf.svg": 1818,
	"./fileIconsByExtension/file-png.svg": 1819,
	"./fileIconsByExtension/file-ppt.svg": 1820,
	"./fileIconsByExtension/file-txt.svg": 1821,
	"./fileIconsByExtension/file-xls.svg": 1822,
	"./fileIconsByExtension/filetype-pdf.svg": 1823,
	"./fileIconsByExtension/filetype-xls.svg": 1824,
	"./flight.png": 1825,
	"./frecuentDestination.svg": 1826,
	"./frontID.svg": 1827,
	"./google-assistant.svg": 1828,
	"./google-play-badge.png": 514,
	"./googleLogo.svg": 1829,
	"./gradiant-background.png": 1830,
	"./gradient.png": 1831,
	"./headerCommandsMobile.svg": 1832,
	"./headerCommandsMobile_old.svg": 1833,
	"./hide.svg": 1834,
	"./icon-history.svg": 1835,
	"./icon-problematic-device.svg": 1836,
	"./imgplaceholder.png": 1837,
	"./inbox.svg": 1838,
	"./incompleteOnboard.svg": 1839,
	"./indeterminate.svg": 1840,
	"./information.svg": 1841,
	"./information_fill.svg": 1842,
	"./left-arrow.svg": 1843,
	"./listIconPoi1.svg": 1844,
	"./listIconPoi2.svg": 1845,
	"./listIconPoi3.svg": 1846,
	"./loanMoney.svg": 1847,
	"./lock--checked.svg": 1848,
	"./lock--unchecked.svg": 1849,
	"./login-header.svg": 1850,
	"./login-logo.svg": 1851,
	"./loginBackground.png": 1852,
	"./logoCompany.svg": 1853,
	"./logoCompanyVerticalWhite.svg": 1854,
	"./logoCompanyWhite.svg": 1855,
	"./logoCompany_old.svg": 1856,
	"./logos/logo-tekbnk.svg": 1857,
	"./logos/rapipago-logo.svg": 1858,
	"./markerFilter1.svg": 677,
	"./markerFilter2.svg": 678,
	"./markerFilter3.svg": 679,
	"./markerLocation.svg": 428,
	"./masterB.png": 1859,
	"./masterP.png": 1860,
	"./mastercard.svg": 1861,
	"./message-icon.svg": 1862,
	"./minus.svg": 1863,
	"./mobile-iphone.svg": 1864,
	"./mobile.svg": 1865,
	"./mobileCommands.svg": 1866,
	"./more_horiz.svg": 1867,
	"./newUser.svg": 1868,
	"./newUser_viejo.svg": 1869,
	"./no-connection.svg": 1870,
	"./note.svg": 1871,
	"./onboarding-hasAccount.png": 1872,
	"./ownershipEcheqs.svg": 1873,
	"./pagos.svg": 1874,
	"./pagos_viejo.svg": 1875,
	"./passport.svg": 1876,
	"./passportEnrollment.svg": 1877,
	"./pause.svg": 1878,
	"./pending-actions.svg": 1879,
	"./pending-dispatch.svg": 1880,
	"./pending-dispatch_viejo.svg": 1881,
	"./perfil.svg": 1882,
	"./perfil_viejo.svg": 1883,
	"./phone-icon.svg": 1884,
	"./place.svg": 1885,
	"./place_viejo.svg": 1886,
	"./play.svg": 1887,
	"./plus.svg": 1888,
	"./plusCircle.svg": 1889,
	"./posicionConsolidada.svg": 1890,
	"./prestamo.svg": 1891,
	"./prestamos.svg": 1892,
	"./prestamos_viejo.svg": 1893,
	"./private.svg": 1894,
	"./process.svg": 1895,
	"./pt-flag.svg": 1896,
	"./radioButtonMark.svg": 1897,
	"./rain.png": 1898,
	"./read-message.svg": 1899,
	"./read-message2.svg": 1900,
	"./read.svg": 1901,
	"./retail.svg": 1902,
	"./retail_viejo.svg": 1903,
	"./reverseID.svg": 1904,
	"./rightArrow.svg": 1905,
	"./schedule.svg": 1906,
	"./schedule_old.svg": 1907,
	"./search.svg": 1908,
	"./security-image.svg": 1909,
	"./selectArrowDown.svg": 1910,
	"./selectArrowUp.svg": 1911,
	"./selectedRecipts.svg": 1912,
	"./selfie-icon.svg": 1913,
	"./send-up.svg": 1914,
	"./sent.svg": 1915,
	"./settings.svg": 1916,
	"./show.svg": 1917,
	"./sign.svg": 1918,
	"./stepCircle.svg": 1919,
	"./stepCircleDone.svg": 1920,
	"./stepCircleWrong.svg": 1921,
	"./styledChevromRight.svg": 1922,
	"./styledClose.svg": 1923,
	"./styledDatepicker-Chevrom-Left.svg": 1924,
	"./styledDatepicker-Chevrom-Right.svg": 1925,
	"./styledSchedule.svg": 1926,
	"./styledmenu-arrow-down-white.svg": 1927,
	"./styledmenu-arrow-down.svg": 1928,
	"./styledmenu-arrow-up.svg": 1929,
	"./styledmenu-close.svg": 1930,
	"./styledmenu-close_Hover.svg": 1931,
	"./styledmenu-hamburger.svg": 1932,
	"./styledmenu-hamburger_Hover.svg": 1933,
	"./success.svg": 1934,
	"./successHand.svg": 1935,
	"./successOnboard.svg": 1936,
	"./sucursal-background.png": 1937,
	"./tablet-android.svg": 1938,
	"./tablet-ipad.svg": 1939,
	"./tablet.svg": 1940,
	"./take-picture.svg": 1941,
	"./tarjetas.svg": 1942,
	"./tarjetas_viejo.svg": 1943,
	"./ticketStatusIcons/alert.svg": 1944,
	"./ticketStatusIcons/check.svg": 1945,
	"./ticketStatusIcons/cross.svg": 1946,
	"./ticketStatusIcons/draft.svg": 1947,
	"./ticketStatusIcons/process.svg": 1948,
	"./ticketStatusIcons/schedule.svg": 1949,
	"./ticketStatusIcons/sign.svg": 1950,
	"./toggleMenu.svg": 1951,
	"./transaction-list.svg": 1952,
	"./transaction-list_viejo.svg": 1953,
	"./transactionStatusIcons/alert.svg": 1954,
	"./transactionStatusIcons/check.svg": 1955,
	"./transactionStatusIcons/cross.svg": 1956,
	"./transactionStatusIcons/draft.svg": 1957,
	"./transactionStatusIcons/process.svg": 1958,
	"./transactionStatusIcons/schedule.svg": 1959,
	"./transactionStatusIcons/sign.svg": 1960,
	"./transferencias.svg": 1961,
	"./transferencias_viejo.svg": 1962,
	"./trash.svg": 1963,
	"./ubicacion.png": 515,
	"./uk-flag.svg": 1964,
	"./user.svg": 1965,
	"./uy-flag.svg": 1966,
	"./visa.svg": 1967,
	"./visaFC.png": 1968,
	"./visaShop.png": 1969,
	"./visaTravel.png": 1970,
	"./warning-login.svg": 1971,
	"./warningIcon.svg": 1972,
	"./whatsapp.svg": 1973
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1277;